module.exports = __webpack_public_path__ + "img/defaultimg.0c7ecaa8.png";